import type { HealthLevel, SystemHealthSummary } from '../types/systemHealth'
import { QUEUE_DEPTH_WARNING, UNPROCESSED_WARNING } from '../constants/systemHealth'

export function deriveHealthLevel(summary: SystemHealthSummary | undefined): HealthLevel {
  if (!summary) return 'yellow'
  if (summary.healthcheckError || summary.status !== 'healthy' || summary.queue.poison > 0) {
    return 'red'
  }
  // Any rejection in the last hour is a warning, not a threshold: in normal
  // running there are none, and the one time there were, a green banner hid
  // 17k of them for six days.
  if (
    summary.queue.depth >= QUEUE_DEPTH_WARNING ||
    summary.unprocessed >= UNPROCESSED_WARNING ||
    (summary.rejectedLastHour ?? 0) > 0
  ) {
    return 'yellow'
  }
  return 'green'
}

export function healthLevelClasses(level: HealthLevel): {
  dot: string
  bg: string
  text: string
  border: string
} {
  switch (level) {
    case 'green':
      return {
        dot: 'bg-green-500',
        bg: 'bg-green-50',
        text: 'text-green-800',
        border: 'border-green-200',
      }
    case 'yellow':
      return {
        dot: 'bg-yellow-500',
        bg: 'bg-yellow-50',
        text: 'text-yellow-800',
        border: 'border-yellow-200',
      }
    case 'red':
      return {
        dot: 'bg-red-500',
        bg: 'bg-red-50',
        text: 'text-red-800',
        border: 'border-red-200',
      }
  }
}

export function healthLevelLabel(level: HealthLevel): string {
  switch (level) {
    case 'green':
      return 'Healthy'
    case 'yellow':
      return 'Warning'
    case 'red':
      return 'Unhealthy'
  }
}
